export default function institutional() {
  $(document).ready(function() {
    $('section.about-us div.bento-grid div.value div.content button').click(function() {
      $('section.about-us div.bento-grid div.value').addClass('active')
      $('section.about-us div.bento-grid div.value').removeClass('desative')
      setTimeout(() => {
        $('section.about-us div.bento-grid div.value div.content').css('zIndex', '0')
        $('section.about-us div.bento-grid div.value div.text').css('zIndex', '3')
      }, 600)
    })

    $('section.about-us div.bento-grid div.value div.text button').click(function() {
      $('section.about-us div.bento-grid div.value').removeClass('active')
      $('section.about-us div.bento-grid div.value').addClass('desative')
      setTimeout(() => {
        $('section.about-us div.bento-grid div.value div.content').css('zIndex', '3')
        $('section.about-us div.bento-grid div.value div.text').css('zIndex', '0')
      }, 400)
    })

    //requisicao de numeros do Greenlike
    if ($('.grid-environmental').length) {
      $.ajax({
        url: 'https://greenlike.com.br/api-numbers',
        method: 'GET',
        success: function(response) {
          let valores = []
          response.contadores.forEach(function(contador) {
            valores.push(contador.value)
          })
          console.log(valores)
          $('.greenlike-plastic').text(valores[0])
          $('.greenlike-plants').text(valores[1])
          $('.greenlike-water').text(valores[2])
          $('.greenlike-meals').text(valores[3])
        },
        error: function(error) {
          console.error('Erro na requisição:', error)
        },
      })
    }
  })
}
